import React from "react";
import { formatValue } from "../widgetFormat";

export default function TableWidget({ definition, payload, onDrilldown }) {
  const data = payload?.data || {};
  const columns = Array.isArray(data.columns) ? data.columns : [];
  const rows = Array.isArray(data.rows) ? data.rows : [];
  const clickable = !!payload?.drilldown;

  return (
    <div
      data-testid={`widget-table-${definition.id}`}
      className="bg-white border border-[var(--border)] p-5 min-h-[240px] flex flex-col"
    >
      <div className="mb-3">
        <div className="font-mono-tech text-[0.6rem] font-bold tracking-[0.25em] text-[var(--text-secondary)]">
          TABLA
        </div>
        <div className="font-display font-bold text-base tracking-tight mt-0.5">
          {definition.title}
        </div>
      </div>
      {rows.length === 0 ? (
        <div className="flex-1 flex items-center justify-center text-sm text-[var(--text-secondary)]">
          Sin datos
        </div>
      ) : (
        <div className="flex-1 overflow-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[var(--border)]">
                {columns.map((c) => (
                  <th
                    key={c.key}
                    className="text-left font-mono-tech text-[0.6rem] tracking-wider text-[var(--text-secondary)] pb-2 pr-3"
                  >
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-b border-[var(--border)] last:border-b-0">
                  {columns.map((c) => (
                    <td key={c.key} className="py-2 pr-3 tabular-nums">
                      {c.format
                        ? formatValue(r[c.key], c.format)
                        : String(r[c.key] ?? "—")}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {clickable && (
        <button
          type="button"
          onClick={() => onDrilldown?.(definition, payload)}
          className="mt-3 font-mono-tech text-[0.65rem] font-bold tracking-wider text-[#0E5FFF] hover:underline text-left"
        >
          {payload.drilldown.label || "Ver detalle →"}
        </button>
      )}
    </div>
  );
}
